const convertDate = (date) => new Date(date).toLocaleString();
export default convertDate;
